import React, {
  Children,
  forwardRef,
  useMemo,
  ReactNode,
} from 'react';
import {
  List,
  useDynamicRowHeight,
  type RowComponentProps,
} from 'react-window';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import { makeStyles } from 'tss-react/mui';

const DEFAULT_ESTIMATED_ITEM_SIZE = 120;
const DEFAULT_PADDING = 8;
const DEFAULT_MAX_HEIGHT = 550;
const DEFAULT_OVERSCAN = 5;

  const useStyles = makeStyles()({
    scroll: scrollBarStyles
  })

interface VariableListboxProps {
  children?: ReactNode;
  estimatedItemSize?: number;
  listPadding?: number;
  maxHeight?: number;
  overscanCount?: number;
  handleItemsRendered: ({ visibleStopIndex }: { visibleStopIndex: number }) => void;
}


type RowProps = {
  items: React.ReactElement[];
  padding: number;
};

function Row({ index, style, items, padding }: RowComponentProps<RowProps>) {
  return (
    <div
      style={{
        ...style,
        top: (style.top as number) + padding,
        height: 'auto',
      }}
    >
      {items[index]}
    </div>
  );
}

const VariableListboxComponent = forwardRef<HTMLDivElement, VariableListboxProps>(
  (props, ref) => {
    const {
      children,
      estimatedItemSize = DEFAULT_ESTIMATED_ITEM_SIZE,
      listPadding = DEFAULT_PADDING,
      maxHeight = DEFAULT_MAX_HEIGHT,
      overscanCount = DEFAULT_OVERSCAN,
      handleItemsRendered,
    } = props;

    const { classes } = useStyles()

    const items = useMemo(
      () => Children.toArray(children) as React.ReactElement[],
      [children],
    );

    const rowHeight = useDynamicRowHeight({
      defaultRowHeight: estimatedItemSize,
    });

    return (
      <div ref={ref} className={classes.scroll}>
          <List
            rowComponent={Row}
            rowProps={{ items, padding: listPadding }}
            rowCount={items.length}
            rowHeight={rowHeight}
            overscanCount={overscanCount}
            style={{ height: maxHeight,marginRight:"0.5rem" }}
            onRowsRendered={(visibleRows) => {
              handleItemsRendered({ visibleStopIndex: visibleRows.stopIndex });
            }}
            className={classes.scroll}
          >
          </List>
      </div>
    );
  },
);

VariableListboxComponent.displayName = 'VariableListboxComponent';

export default VariableListboxComponent;